import { Button } from '@tailark/core/ui/button'
import { Card, CardContent } from '@tailark/core/ui/card'
import Link from 'next/link'
import React from 'react'

export default function CTA1() {
    const ctaHref = 'https://app.lummeny.com'
    return (
        <section className="bg-background py-12 md:py-24">
            <div className="mx-auto max-w-5xl px-6">
                <Card>
                    <div className="max-lg:mask-b-from-35% max-lg:pt-6 max-md:mt-4 lg:absolute lg:inset-0 lg:top-12 lg:mr-auto lg:w-2/5">
                        <div
                            aria-hidden="true"
                            className="relative">
                            <div className="z-1 bg-card absolute -right-6 -top-6 bottom-0 left-[13rem] rounded-xl border shadow-xl"></div>
                            <div className="mask-b-from-50% rounded-xl border">
                                <div className="absolute inset-y-0 left-0 w-[12rem] border-r">
                                    <div className="flex gap-1.5 px-4 pt-4">
                                        <div className="bg-foreground/5 border-foreground/5 size-2 rounded-full border"></div>
                                        <div className="bg-foreground/5 border-foreground/5 size-2 rounded-full border"></div>
                                        <div className="bg-foreground/5 border-foreground/5 size-2 rounded-full border"></div>
                                    </div>
                                </div>
                                <div className="me-auto w-[calc(100%-12rem)]">
                                    <div className="h-11 border-b"></div>
                                    <div className="relative h-[10rem]">
                                        <div className="absolute inset-0 bg-[repeating-linear-gradient(-45deg,var(--color-border),var(--color-border)_1px,transparent_1px,transparent_6px)] opacity-50"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CardContent>
                        <div className="max-w-xl max-md:pr-8">
                            <div className="relative">
                                <h2 className="text-foreground text-balance text-3xl font-semibold md:text-4xl">Create, Sell and Grow</h2>
                                <p className="text-muted-foreground mb-6 mt-4 text-balance">Join a community of over 1000+ companies and developers who have already discovered the power of Tailark. </p>
                                <Button asChild size="lg">
                                    <Link href={ctaHref}>
                                        <span>Contact Sales</span>
                                    </Link>
                                </Button>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </section>
    )
}